<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="title"
             :icon="icon"
             @opened="open">
    <div class="row">
      <!-- begin form left -->
      <div class="col-6">
        <div class="form-group kt-form__group">
          <label :for="'notification_name_' + notification.id">Name</label>
          <input v-model="notification.name" type="text" class="form-control kt-input">
        </div>

        <div class="form-group kt-form__group">
          <label :for="'notification_body_' + notification.id">Notification Body</label>
          <textarea :id="'notification_body_' + notification.id" v-model="notification.body"
                    class="form-control kt-input"
                    rows="3" />
          <small class="font-italic mt-2">
            <i class="la la-info-circle" />All HTML is allowed
          </small>
        </div>

        <div class="form-group kt-form__group">
          <label :for="'notification_style_' + notification.id">Example select</label>
          <select :id="'notification_style_' + notification.id" v-model="notification.style_classes" class="form-control kt-input">
            <option value="alert-">
              Default
            </option>
            <option value="alert-outline-">
              Outline
            </option>
            <option value="alert-solid-">
              Faded background
            </option>
          </select>
        </div>

        <div class="form-group kt-form__group">
          <label :for="'notification_color_' + notification.id">Notification Color</label>
          <select :id="'notification_color_' + notification.id" v-model="notification.colour_classes" class="form-control kt-input">
            <option value="success">
              Success
            </option>
            <option value="info">
              Info
            </option>
            <option value="warning">
              Warning
            </option>
            <option value="danger">
              Danger
            </option>
            <option value="primary">
              Primary
            </option>
            <option value="light">
              Light
            </option>
            <option value="dark">
              Dark
            </option>
          </select>
        </div>

        <div class="kt-form__group form-group">
          <div class="d-flex flex-column">
            <ss-checkbox id="notification-has-icon" v-model="notification.has_icon">
              Add left Icon
            </ss-checkbox>
            <ss-checkbox id="notification-elevate" v-model="notification.elevate">
              Elevate
            </ss-checkbox>
          </div>
        </div>

        <div v-if="notification.has_icon" class="form-group kt-form__group">
          <label :for="'notification_icon_' + notification.id">Enter your icon</label>
          <input :id="'notification_icon_' + notification.id" v-model="notification.icon"
                 type="text"
                 class="form-control kt-input" placeholder="la la-bell">
          <span class="kt-form__help">
            <a target="_blank" href="https://icons8.com/line-awesome?search=filter">See available icons</a>
          </span>
        </div>
      </div>
      <!-- end form left -->

      <!-- begin form right -->
      <div class="col-6">
        <div class="kt-form__group form-group">
          <label>&nbsp;</label>
          <div class="d-flex flex-column">
            <ss-checkbox id="notification-published" v-model="notification.published">
              Published
            </ss-checkbox>
          </div>
        </div>

        <div v-if="!notification.published" class="kt-form__group form-group">
          <label :for="'notification_publish_at_' + notification.id">Publish At</label>
          <datetime :id="'notification_publish_at_' + notification.id" v-model="notification.publish_at"
                    input-class="form-control kt-input"
                    type="datetime" format="yyyy-MM-dd HH:mm:ss" />
        </div>

        <div class="kt-form__group form-group">
          <label :for="'notification_publish_until_' + notification.id">Publish Until</label>
          <datetime :id="'notification_publish_until_' + notification.id" v-model="notification.publish_until"
                    input-class="form-control kt-input"
                    type="datetime" format="yyyy-MM-dd HH:mm:ss"
                    :min-datetime="min_publish_until" />
        </div>
      </div>
    <!-- end form right -->
    </div>

    <div class="row">
      <div class="col-12">
        <div class="kt-divider">
          <span />
          <span>Preview</span>
          <span />
        </div>
      </div>
    </div>

    <div v-if="notification.body" class="row">
      <div class="col-12">
        <!-- start preview -->
        <div id="notification_preview" class="col-12">
          <dashboard-notification :notification="notification" :set-cookie-on-dismiss="false" />
        </div>
      <!-- end preview -->
      </div>
    </div>
    <template slot="body-controls">
      <button type="button"
              class="btn btn-ss-standout"
              :disabled="saving"
              @click="saveNotification">
        <b-spinner v-if="saving" small label="Saving..." /> Save Notification
      </button>
      <button type="button" class="btn btn-ss" @click="() => close(false)">
        Close
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModalMixin from 'VueModals/VjsModalMixin';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import DashboardNotification from "VuePartials/DashboardNotificationsShow";
import toastr from 'toastr';

export default {
  components: { Datetime, DashboardNotification },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'dashboard-notifications-modal',
    },
    title: {
      type: String,
      required: false,
      default: 'Create Notification',
    },
    icon: {
      type: String,
      required: false,
      default: 'la la-bell',
    },
    loadedNotification: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    notification: {
      id: null,
      name: null,
      body: null,
      published: null,
      publish_at: null,
      publish_until: null,
      style_classes: "default",
      colour_classes: "success",
      has_icon: false,
      icon: 'la la-bell',
    },
    saving: false,
  }),
  computed: {
    min_publish_until() {
      return moment(this.publish_at).add(1, 'minutes').toISOString();
    },
  },
  methods: {
    resetData() {
      this.notification.name = null;
      this.notification.body = null;
      this.notification.published = null;
      this.notification.publish_at = null;
      this.notification.publish_until = null;
      this.notification.style_classes = "default";
      this.notification.colour_classes = "alert-success";
      this.notification.has_icon = false;
      this.notification.icon = "la la-bell";
    },
    async saveNotification() {
      if (!this.notification.name) {
        toastr.error("A name is required");
        return;
      }

      if (!this.notification.published && !this.notification.publish_at) {
        toastr.error("Either set to published to choose a publish at datetime");
        return;
      }

      if (!this.notification.body) {
        toastr.error("Notification must have a body");
      }

      try {
        this.saving = true;
        const response = await axios.post('/api/v1/admin/dashboard-notifications', {
          notification_id: this.notification.id,
          name: this.notification.name,
          body: this.notification.body,
          published: this.notification.published,
          publish_at: this.notification.publish_at,
          publish_until: this.notification.publish_until,
          style_classes: this.notification.style_classes,
          colour_classes: this.notification.colour_classes,
          has_icon: this.notification.has_icon,
          icon: this.notification.icon,
        });

        this.saving = false;

        if (response.data.data) {
          if (!this.notification.id) {
            EventBus.$emit("notification-added", response.data.data.notification);
            this.resetData();
          } else {
            EventBus.$emit("notification-updated", response.data.data.notification);
          }
          toastr.success('Saved');
        }
        this.close(true);
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    open() {
      if (this.loadedNotification) {
        this.notification.id = this.loadedNotification.id;
        this.notification.name = this.loadedNotification.name;
        this.notification.body = this.loadedNotification.body;
        this.notification.published = this.loadedNotification.published;
        this.notification.publish_at = moment(this.loadedNotification.publish_at).toISOString();
        this.notification.publish_until = moment(this.loadedNotification.publish_until).toISOString();
        this.notification.style_classes = this.loadedNotification.style_classes;
        this.notification.colour_classes = this.loadedNotification.colour_classes;
        this.notification.has_icon = this.loadedNotification.has_icon;
        this.notification.icon = this.loadedNotification.icon;
      } else {
        this.notification.style_classes = 'alert-';
        this.notification.body = `<h4>A Title for the notification</h4>
<p>This is how you do a paragraph</p>
break text onto a new<br/>
line<br/>
<strong>Some bold text</strong> <i>Some italic text </i><br/>
A link <a href="https://icons8.com/line-awesome?search=filter">Line-Awesome icons</a>`;
      }
    },
    close(confirm) {
      this.complete({
        confirm,
        notification: this.notification,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
